import { environment } from '../../environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { UsersProject } from "./user-management.model";

import { AuthService, IUserInfo, IUserInProject } from '../shared/core/index';
import { HttpService } from '../shared/core/http.service';
import { map, tap, catchError, switchMap, distinctUntilChanged, debounceTime } from 'rxjs/operators';

@Injectable()
export class UserManagementService {

    private _userInfo: IUserInfo;
    private ciServiceUrl = new URL('ci', environment.apiUrl).toString();
    private historyUrl = new URL('history', environment.apiUrl).toString();
    private usersManagementServiceUrl = new URL('usersmanagement', environment.apiUrl).toString();
    private usersManagementByNameEmailServiceUrl = new URL('usersmanagement/bynameemail', environment.apiUrl).toString();
    private lookupsUrl = new URL('lookups', environment.apiUrl).toString();

    constructor(private _httpService: HttpService, private _authService: AuthService) {
        this._authService.subscribeToLoginService().subscribe(r => { this._userInfo = r });
    }

    getUsersInProject(projectId: string): Observable<IUserInProject[]> {
        return this._httpService.httpGet(this.usersManagementServiceUrl + '?pid=' + projectId).pipe(
        map((response: any) => {
                console.log(response);
                return this.toUserProjectInfo(response)
            }
            ),
            tap(data => data));

        // .catch((e) => {
        //     // handle e and return a safe value or rethrow
        //     console.error('error on UserManagementService.search(): ' + e);
        //     return Observable.of<any>([]);
        // });
    }

    toUserInfo(r: any): IUserInfo[] {
        console.log('toUserInfo() >> r: ' + JSON.stringify(r));

        let incomingUsers = r;
        var ret: IUserInfo[] = new Array<IUserInfo>();

        incomingUsers.forEach(element => {
            let userInfo = <IUserInfo>
                ({
                    userId: element.UserId,
                    userName: element.UserName,
                    name: element.Name,
                    organizationId: element.OrganizationId,
                    organizationName: element.OrganizationName,
                    photoUrl: element.PhotoUrl,
                    lastLoginDate: element.LastLoginDate,
                    email: element.Email,
                    status: element.Status

                });
            ret.push(userInfo);

        });
        return ret;
    }

    toUserProjectInfo(r: any): IUserInProject[] {
        console.log('toUserProjectInfo() >> r: ' + JSON.stringify(r));

        let incomingUsers = r;
        console.log('toUserProjectInfo() >> incomingUsers: ' + JSON.stringify(incomingUsers));

        let userInfo: UsersProject = new UsersProject();

        userInfo.projectId = incomingUsers.ProjectId;

        if (incomingUsers.Users.length > 0){
            userInfo.users = []; 
        }

        incomingUsers.Users.forEach(up => {
            var newUserInfo: IUserInProject = new IUserInProject();
            newUserInfo.id = up.Id;
            newUserInfo.userId = up.User.UserId,
            newUserInfo.userName = up.User.UserName,
            newUserInfo.name = up.User.Name,
            newUserInfo.organizationId = up.User.OrganizationId,
            newUserInfo.organizationName = up.User.OrganizationName,
            newUserInfo.photoUrl = up.User.PhotoUrl
            newUserInfo.lastLoginDate = up.User.LastLoginDate
            newUserInfo.email = up.User.Email
            userInfo.users.push(newUserInfo);

        });

        console.log('toUserProjectInfo() >> userInfo.users: ' + JSON.stringify(userInfo.users));

        return userInfo.users;
    }

    updateUsersProject(project: UsersProject): Observable<boolean> {

        var userProjectCopy: UsersProject;

        
        userProjectCopy = JSON.parse(JSON.stringify(project));
        console.log('calling updateProject() at ' + this.usersManagementServiceUrl + ' for project: ' + JSON.stringify(userProjectCopy.projectId));

        var body = JSON.stringify(userProjectCopy);

        return this._httpService.httpPost(this.usersManagementServiceUrl, body)
            .pipe(
                map(() => true), 
                catchError(e => {
                    console.error('updateUsersProject:' + e);
                    return of(false);
                })
            );
    };

    

    search(terms: Observable<string>, isExactMatch = false, debounceDuration = 200): Observable<IUserInfo[]> {

        return terms.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(term => this.rawSearch(term)),
            catchError((e) => {
                // handle e and return a safe value or rethrow
                console.error('error on UserManagementService.search(): ' + JSON.stringify(e));
                return [];
            }));
    }

    rawSearch(term: string): Observable<IUserInfo[]> {
        
        if (term.trim() == '') {
            return of(new Array<IUserInfo>());
        }

        console.log('UserManagementService.rawSearch(): ' + term);

        let token = this._authService.accessDetails.access_token;

        return this._httpService.httpGet(this.usersManagementServiceUrl + '?u=' + encodeURI(term)).pipe(
            map((response) => {
                return this.toUserInfo(response);
                // return <IUserInfo[]>response.json();
                // console.log('odne...');
            }
            ),
            tap(data => data),
            catchError(e => {
                console.error('UserManagementService.rawSearch: ' + e);
                return of(new Array<IUserInfo>());
            }));
    }

    private handleError(error) {
        // console.error('error!:' + error.json());
        console.error('UserManagementService.handleError():error:' + error);
        return throwError(() => error || 'Server error');
    }

    rawSearchByNameEmail(term: string): Observable<IUserInfo[]> {
        if (term.trim() == '') {
            return of(new Array<IUserInfo>());
        }

        console.log('UserManagementService.rawSearchByNameEmail(): ' + term);

        let token = this._authService.accessDetails.access_token;

        return this._httpService.httpGet(this.usersManagementByNameEmailServiceUrl + '?u=' + encodeURI(term)).pipe(
            map((response) => {
                return this.toUserInfo(response);
            }
            ),
            tap(data => {
                console.log(`UserManagementService.rawSearchByNameEmail: ${data.length} results found for '${term}'`);    
                return data}
                ),
            catchError(e => {
                console.log('Error in UserManagementService.rawSearchByNameEmail: ' + e);
                return of(new Array<IUserInfo>());
            }));
    }
}
